import { Col, Row } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { TileContainerExt } from '~src/modules/companySettings/shared.sc';
import { ReportEntityTypes } from '~src/modules/reports/interfaces/header.interface';
import { ApiReduxResp } from '~src/services/apiMiddleware';
import SvgIcon from '~src/shared/SvgIcon';
import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';
import { SectionHeader } from '~src/shared/form/shared.sc';
import { showNotification } from '~src/store/app/actions';
import { ShowNotification } from '~src/store/app/interfaces';
import { fetchExports, initTotalExport } from '~src/store/exports/actions';
import { TextBox } from '~src/styles/containers.sc';

import { InProgressText } from './exportAnswersData.sc';

interface DispatchProps {
  showNotification: ShowNotification;

  initTotalExport(exportType: string): ApiReduxResp;
}

type Props = DispatchProps;

const ExportAnswersData: FC<Props> = (props) => {
  const [t] = useTranslation();
  const [exportIsRunning, setExportIsRunning] = useState<boolean>(false);
  const [exportCheckTimeout, setExportCheckTimeout] = useState<number>(0);
  const startExport = () => initializeExport('csv');

  const checkExport = () => {
    (async () => {
      const rsp = await fetchExports(ReportEntityTypes.Total, 'running').callAPI();
      setExportIsRunning(rsp.data.length > 0);
      if (rsp.data.length > 0) {
        setExportCheckTimeout(window.setTimeout(checkExport, 2000));
      }
    })();
  };

  useEffect(() => {
    checkExport();
    return () => {
      window.clearTimeout(exportCheckTimeout);
    };
  }, [exportIsRunning]);

  const initializeExport = (type: string) => {
    props.initTotalExport(type).then((rsp) => {
      setExportIsRunning(true);
      if (rsp.error) {
        props.showNotification({
          txtKey: 'x.reports.export.error.' + rsp.error.response.data.translation_key,
          id: 'export_error',
        });
      }
    });
  };

  return (
    <TileContainerExt>
      <SectionHeader $inTile data-translation="x.company.export_answers.title">
        {t('x.company.export_answers.title')}
      </SectionHeader>
      <Row gutter={30}>
        <Col span={12}>
          <TextBox data-translation="x.company.export_answers.info_col1">
            {t('x.company.export_answers.info_col1')}
          </TextBox>
        </Col>
        <Col span={12}>
          <TextBox data-translation="x.company.export_answers.info_col2">
            {t('x.company.export_answers.info_col2')}
          </TextBox>
        </Col>
      </Row>
      <Row gutter={30}>
        <Col span={12}>
          {exportIsRunning ? (
            <InProgressText>{t('x.company.export_answers.pending_text')}</InProgressText>
          ) : (
            <SecondaryButton data-translation="x.reports.export.type_csv" onClick={startExport}>
              <SvgIcon width={25} viewBoxWidth={1000} name={'iconCsv'} />
              &nbsp;{t('x.reports.export.type_csv')}
            </SecondaryButton>
          )}
        </Col>
      </Row>
    </TileContainerExt>
  );
};

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  initTotalExport: (type) => dispatch(initTotalExport(type)),
  showNotification: (notification) => dispatch(showNotification(notification)),
});

const ExportAnswersDataC = connect(null, mapDispatchToProps)(ExportAnswersData);

export default ExportAnswersDataC;
